<template>
  <div class="park_detail">
    <div class="m">
      <el-breadcrumb separator-class="el-icon-caret-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/investment_info`}">园区列表</el-breadcrumb-item>
        <el-breadcrumb-item v-if="info">{{info.type_name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 v-if="info">{{info.name}}</h3>
      <div class="picture_box">
        <div class="picture_box_l">
          <!-- 照片预览区 -->
          <div class="bigPicture_box">
            <img
              class="vr_big"
              src="https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/hz_space_star/img/vr.png"
              v-if="vrId && info.image_detailsPath[0] === preview"
              @click="showVR"
            />
            <img :src="preview" />
          </div>
          <!-- 照片列表 -->
          <div class="litPicture_box mt20" v-if="info">
            <i class="el-icon-arrow-left l" @click="pictureUp" />
            <i class="el-icon-arrow-right r" @click="pictureDown" />
            <ul :style="{left:long+'px'}" v-if="info.image_detailsPath.length">
              <li v-for="(item,index) in info.image_detailsPath" @click="changePreview(item)">
                <!-- vr点击入口 -->
                <img
                  class="vr_small"
                  src="https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/hz_space_star/img/vr.png"
                  v-if="vrId && index === 0"
                  @click="showVR"
                />
                <img :src="item" />
              </li>
            </ul>
          </div>
        </div>
        <!-- 预约 -->
        <div class="appointment_box">
          <div class="up_box">
            <div class="up_box_l">园区信息</div>
          </div>
          <div class="centre_box" v-if="info">
            <div>
              <span>面积：</span>
              <span>{{info.area}}㎡</span>
            </div>
            <div>
              <span>地址：</span>
              <span>{{info.address}}</span>
            </div>
            <div>
              <span>地铁：</span>
              <span>{{info.subway}}</span>
            </div>
            <div>
              <span>公交：</span>
              <span>{{info.bus}}</span>
            </div>
          </div>
          <router-link
            class="btn"
            to="/personal_center/enterprise/admission_to_the_park/admission_to_the_park_certificaiton_table_list"
          >立即入驻</router-link>
        </div>
      </div>
      <!-- 点击跳转定位 -->
      <div class="tab mt20">
        <div class="tab_item active">房源信息</div>
        <div class="tab_item" @click="scroll('mao')">园区介绍</div>
      </div>
      <!-- 办公空间选择 -->
      <ul class="nav_box">
        <li :class="{active:type==='MeetingTypeOffice'}" @click="changeTab('MeetingTypeOffice')">办公室</li>
        <li
          :class="{active:type==='MeetingTypeStation'}"
          @click="changeTab('MeetingTypeStation')"
        >开放工位</li>
        <li
          :class="{active:type==='MeetingTypeMeeting'}"
          @click="changeTab('MeetingTypeMeeting')"
        >会议室</li>
        <li :class="{active:type==='MeetingTypeOther'}" @click="changeTab('MeetingTypeOther')">其它</li>
      </ul>
      <!-- 办公空间列表 -->
      <ul class="park_offic_list">
        <template v-for="(item,idx) in list">
          <li class="park_offic_list_item" v-if="idx<4" :key="item.id">
            <router-link
              :to="`office_space_detail?id=${item.id}&incubator_id=${item.incubator_id}`"
              class="park_offic_list_item_a"
            >
              <img class="l" v-lazy="item.coverPath" />
              <div class="r">
                <h3>{{item.name}}</h3>
                <h4>
                  {{item.area}}m²
                  <span>|</span>
                  {{item.floor}}
                  <span>|</span>
                  {{item.direction}}
                </h4>
                <h5 v-if="item.money  !== ''">
                  <span>{{item.money}}</span>
                  <template v-if="item.type==='MeetingTypeMeeting'">元/半小时</template>
                  <template v-else-if="item.type==='MeetingTypeOffice'">元/间/月</template>
                  <template v-else-if="item.type==='MeetingTypeStation'">元/个/月</template>
                  <template v-else-if="item.type==='MeetingTypeOther'">元/间/月</template>
                  <template v-else>元/㎡/月</template>
                </h5>
                <h5 v-else>
                  <span>面议</span>
                </h5>
              </div>
            </router-link>
          </li>
        </template>
      </ul>
      <router-link
        :to="`/investment_info_office_space?incubator_id=${$route.query.incubator_id}&type=${type}`"
        class="more_space mt20"
      >查看更多({{totle}})</router-link>

      <!-- <div class="intro_box">
        <h2 id="mao">园区信息</h2>
        <div class="intro" v-if="info">
          <ul class="intro_l">
            <li>
              <span>园区名称：</span>
              {{info.name}}
            </li>
            <li>
              <span>位置：</span>
              {{info.address}}
            </li>
            <li>
              <span>公交：</span>
              {{info.bus}}
            </li>
          </ul>
          <ul class="intro_r">
            <li>
              <span>占地面积：</span>
              {{info.area}}㎡
            </li>
            <li>
              <span>地铁：</span>
              {{info.subway}}
            </li>
          </ul>
        </div>
      </div>-->
      <div class="summarize_box">
        <h3 id="mao">园区介绍</h3>
        <div class="ck-text" v-html="info.synopsis" v-if="info"></div>
      </div>
    </div>
    <!-- 预约弹窗 -->
    <make_an_appointment
      :dialogVisible="dialogVisible"
      :itemObj="info"
      @close="dialogVisible=false"
    />
    <el-dialog
      :visible.sync="dialogVisible2"
      width="976px"
      @opened="initVR"
      :before-close="removeVr"
      custom-class="vr_box"
    >
      <!-- vr容器 -->
      <div id="pano" style="width:960px; height:540px;" v-if="vrId"></div>
    </el-dialog>
  </div>
</template>

<script>
import make_an_appointment from "../components/make_an_appointment.vue";
export default {
  components: {
    make_an_appointment
  },
  data() {
    return {
      long: 0, //控制图片滚动长度
      toSize: 0, //控制图片滚动状态
      listSize: 10, //获取所有图片长度
      dialogVisible: false,
      dialogVisible2: false, //vr
      info: null, //会议室信息
      preview: "", //图片预览
      type: "MeetingTypeOffice", //办公空间类型
      list: [], //办公空间列表
      totle: 0, //办公位总数
      vrId: "", //vr的id
      first: true //第一次打开VR
    };
  },
  created() {
    this.getIncubators(); //获取园区信息
    this.getList(); //办公室信息
  },
  methods: {
    showVR() {
      this.dialogVisible2 = true;
    },
    removeVr() {
      this.dialogVisible2 = false;
      removepano("test");
    },
    // 初始krpano
    initVR() {
      let xml = `${this.process.env.VUE_APP_HZW_URL}/business/vr/BVrController/tour?id=${this.vrId}`;
      embedpano({
        swf:
          "https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/hz_space_star/krpano/krpano.swf",
        xml: xml,
        target: "pano",
        html5: "auto",
        mobilescale: 1.0,
        passQueryParameters: true,
        id: "test"
      });
    },
    // 滚动至DOM id
    scroll(id) {
      let dom = document.getElementById(id);
      let _top = dom.offsetTop;
      window.scroll(0, _top);
    },
    // tab切换
    changeTab(type) {
      this.type = type;
      this.getList();
    },
    /*获取园区信息*/

    getIncubators() {
      let params = {
        id: this.$route.query.incubator_id
      };
      this.api.getIncubators(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list,
          info = list.length ? list[0] : null;
        //标签处理
        if (info) {
          info.key_word = info.key_word.trim().split("|");
          info.image_detailsPath = info.image_detailsPath.length
            ? info.image_detailsPath.trim().split("|")
            : [];
          this.preview = info.image_detailsPath
            ? info.image_detailsPath[0]
            : ""; //预览图
          info.area = parseFloat(info.area).toFixed(2);
          this.info = info;
        }

        this.$store.dispatch("setOtherParkInfo", info);

        if (info && info.vr) {
          this.vrId = info.vr;
          this.preview = info.vr_coverPath;
          info.image_detailsPath.unshift(info.vr_coverPath);
        }
      });
    },
    /*获取办公空间列表*/
    getList() {
      let params = {
        incubator: this.$route.query.incubator_id,
        type: this.type,
        pageSize: 4,
        is_exhibition: true
      };
      this.api.getFontMeetings(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list || [];
        list.forEach(item => {
          item.key_word = item.key_word.trim().split("|");
          item.area = parseFloat(item.area).toFixed(2);
        });
        this.list = list;
        this.totle = res.obj.totalSize;
      });
    },
    // 向左切换图片
    pictureUp() {
      if (
        this.itemObj.image_detailsPath.length > 0 &&
        Math.abs(this.long) >= 90
      ) {
        this.long += 90;
        this.toSize--;
      }
    },
    //向右切换图片
    pictureDown() {
      if (
        this.itemObj.image_detailsPath.length > 9 &&
        this.toSize < this.itemObj.image_detailsPath.length - 9
      ) {
        this.long -= 90;
        this.toSize++;
      }
    },
    changePreview(item) {
      this.preview = item;
    }
  }
};
</script>

<style lang="scss">
.park_detail {
  background: #fff;
  .vr_box {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__headerbtn {
      background: rgba(250, 250, 250, 0.5);
      position: absolute;
      right: -50px;
      top: 0;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      .el-dialog__close {
        color: #fff;
        font-size: 14px;
      }
    }
    .el-dialog__body {
      padding: 8px;
    }
  }
  .m {
    padding: 20px 0 80px;
    .el-breadcrumb {
      .el-breadcrumb__inner {
        line-height: 34px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    h3 {
      line-height: 70px;
      font-size: 30px;
      font-weight: 400;
      color: #333333;
    }
    .picture_box {
      display: flex;
      align-items: flex-start;

      .picture_box_l {
        width: 780px;
        margin-right: 20px;
        .bigPicture_box {
          width: 780px;
          height: 400px;
          position: relative;
          .vr_big {
            position: absolute;
            width: 72px;
            height: 72px;
            top: 50%;
            left: 50%;
            margin-top: -36px;
            margin-left: -36px;
            cursor: pointer;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .litPicture_box {
          height: 80px;
          overflow: hidden;
          position: relative;
          display: flex;
          padding: 0 40px;
          i {
            width: 30px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            background: #343434;
            position: absolute;
            z-index: 999;
            cursor: pointer;
            font-size: 28px;
            color: #fff;
          }
          .l {
            left: 0;
          }
          .r {
            right: 0;
          }
          .el-icon-arrow-down {
            bottom: 0px;
          }
          ul {
            position: relative;
            transition: all 0.4s;
            display: flex;
            width: 100%;
            li {
              width: 120px;
              height: 80px;
              background: $bg-darkgray;
              cursor: pointer;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .vr_small {
                object-fit: contain;
                position: absolute;
                width: 42px;
                height: 42px;
                top: 50%;
                left: 50%;
                margin-top: -21px;
                margin-left: -21px;
              }
            }
            li + li {
              margin-left: 10px;
            }
          }
        }
      }
      .appointment_box {
        width: 400px;
        border: 1px solid #e9e9e9;
        box-sizing: border-box;
        padding-bottom: 30px;
        .up_box {
          padding: 30px;
          display: flex;
          justify-content: space-between;
          position: relative;
          &:after {
            content: "";
            height: 0;
            width: 340px;
            border-bottom: 1px solid #eee;
            background: #eee;
            position: absolute;
            bottom: 0;
          }
          .up_box_l {
            font-size: 30px;
            font-weight: bold;
            color: #343434;
          }

          .collection_btn {
            display: inline-block;
            color: #999;
            height: 26px;
            line-height: 26px;
            border-radius: 13px;
            padding: 0 11px;
            background: $bd-color;
            border: 1px solid $bd-color;
            cursor: pointer;
            i {
              margin-right: 6px;
            }
          }
          .collection_btn.active {
            color: #ff733c;
          }
          span:nth-child(1) {
            font-size: 30px;
            font-weight: 400;
            color: #ff733c;
            margin-right: 6px;
          }
          span:nth-child(2) {
            font-size: 14px;
            font-weight: 400;
            color: #ff733c;
          }
        }
        .price_box {
          padding: 0 30px;
          height: 83px;
          line-height: 83px;
          color: #ff4e5a;
          font-size: 30px;
          font-weight: bold;
          span:last-child {
          }
        }
        .centre_box {
          padding: 20px 30px;
          div {
            font-size: 14px;
            line-height: 34px;
            span:nth-child(1) {
              color: #9a9a9a;
            }
            span:nth-child(2) {
              color: #343434;
            }
          }
        }
        .btn {
          display: block;
          width: 340px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          background: #4c84ff;
          font-size: 16px;
          color: #ffffff;
          margin: 20px auto 0;
          cursor: pointer;
        }
        .down_box {
          padding: 20px 30px 10px;
          .el-icon-time {
            display: none;
          }
          .el-input__inner {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            width: 328px;
            height: 42px;
            line-height: 42px;
            padding-left: 12px;
          }
          p {
            line-height: 46px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
          }
          .el-button--small {
            width: 328px;
            height: 42px;
            background: #333333;
            font-size: 14px;
            font-weight: 400;
            color: #fff;
            margin-top: 20px;
          }
        }
      }
    }
    .msg_tag {
      display: flex;
      margin-top: 10px;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 68px;
        height: 26px;
        background: rgb(241, 237, 237);
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        padding: 5px;
        margin-right: 10px;

        box-sizing: border-box;
      }
    }
    .tab {
      display: flex;
      align-items: center;
      height: 56px;
      border-bottom: 1px solid #eee;
      width: 780px;
      .tab_item {
        font-size: 16px;
        font-weight: bold;
        color: #343434;
        position: relative;
        cursor: pointer;
      }
      .tab_item.active {
        color: #4c84ff;
      }
      .tab_item.active::after {
        content: "";
        width: 64px;
        height: 2px;
        background: #4c84ff;
        position: absolute;
        bottom: -20px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
      .tab_item + .tab_item {
        margin-left: 50px;
      }
    }
    .nav_box {
      display: flex;
      margin: 30px 0;
      li {
        padding: 10px 8px;
        font-size: 14px;
        background: #f5f5f5;
        color: #666;
        cursor: pointer;
      }
      li.active {
        background: rgba(76, 132, 255, 0.1);
        color: #4c84ff;
      }
      li + li {
        margin-left: 14px;
      }
    }
    .intro_box {
      padding: 45px 0 15px;
      width: 780px;
      h2 {
        font-size: 20px;
        font-weight: 800;
        color: #343434;
        height: 50px;
        line-height: 50px;
      }
      .intro {
        display: flex;
        justify-content: space-between;
        ul {
          width: 48%;
          li {
            display: flex;
            height: 44px;
            span {
              color: #9a9a9a;
              min-width: 90px;
            }
            font-size: 14px;
            line-height: 20px;
            color: #343434;
          }
        }
      }
    }
    .park_offic_list {
      .park_offic_list_item {
        .park_offic_list_item_a {
          display: flex;
          .l {
            width: 206px;
            height: 154px;
            border-radius: 4px;
            object-fit: cover;
            object-position: center;
          }
          .r {
            margin-left: 30px;
            h3 {
              font-size: 20px;
              color: #343434;
              font-weight: bold;
              line-height: 40px;
            }
            h4 {
              font-size: 14px;
              color: #9a9a9a;
              line-height: 33px;
              span {
                padding: 0 10px;
              }
            }
            h5 {
              span {
                font-weight: bold;
                font-size: 30px;
              }
              margin-top: 30px;
              color: #ff4e5a;
              font-size: 14px;
            }
          }
        }
      }
      .park_offic_list_item + .park_offic_list_item {
        margin-top: 30px;
      }
    }
    .more_space {
      display: block;
      width: 780px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      color: #666666;
      font-size: 16px;
    }
    .summarize_box,
    .facility_box {
      padding-top: 30px;
      h3 {
        line-height: 60px;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }
    .summarize_box {
      width: 792px;
      ul {
        display: flex;
        border-top: 1px solid $bd-color;
        border-bottom: 1px solid $bd-color;
      }
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 88px;
        span {
          font-size: 20px;
          color: #333;
        }
        em {
          font-size: 14px;
          color: #999;
          margin-top: 14px;
        }
      }
    }
    .facility_box {
      width: 792px;
      .facility_inner_box {
        display: flex;
        flex-wrap: wrap;
        .facility_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 70px;
          margin: 0 50px 20px 0;
          em {
            font-style: normal;
            font-size: 30px;
            color: #999;
          }
          span {
            font-size: 14px;
            color: $font-gary;
            line-height: 30px;
            white-space: nowrap;
          }
        }
      }
    }

    //弹出框样式
    .el-dialog {
      width: 388px;
      border: 1px solid #dedede;
      padding: 14px 28px 58px 30px;
      border-radius: 6px;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0px !important;
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          line-height: 74px;
          font-size: 28px;
          color: #333333;
          font-weight: 700;
        }
        .el-dialog__headerbtn {
          display: none;
        }
      }
      .el-dialog__body {
        padding: 0;
      }
      .el-form {
        .el-form-item--small:nth-child(4) {
          margin-bottom: 32px;
        }
        .el-input__inner {
          height: 40px;
        }
        .el-button {
          width: 100%;
          height: 40px;
          background: #333333;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
</style>